import { render } from "./teachStudioManage.vue?vue&type=template&id=07dca92b&scoped=true"
import script from "./teachStudioManage.vue?vue&type=script&lang=js"
export * from "./teachStudioManage.vue?vue&type=script&lang=js"

import "./teachStudioManage.vue?vue&type=style&index=0&id=07dca92b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dca92b"]])

export default __exports__